module.exports = __webpack_public_path__ + "media/about/PhotokivePreview-dc48fe46.jpg";